var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNeedle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43,
    height: 125.082,
    viewBox: "0 0 43 125.082",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .needle-cls-1 {\n        fill: #171443;\n      }\n\n      .needle-cls-2 {\n        fill: #66c;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3851",
    name: "Group 3851",
    transform: "translate(-0.345)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5604",
    name: "Path 5604",
    className: "needle-cls-1",
    d: "M106.906,110.2H88.378a3.847,3.847,0,0,1-3.818-4.318l9.264-102.5a3.847,3.847,0,0,1,7.636,0l9.264,102.5a3.847,3.847,0,0,1-3.818,4.318",
    transform: "translate(-75.767)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3836",
    name: "Group 3836",
    transform: "translate(0 82.565)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_660",
    name: "Ellipse 660",
    className: "needle-cls-1",
    cx: 21.5,
    cy: 21.5,
    r: 21.5,
    transform: "translate(0.345 -0.483)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_661",
    name: "Ellipse 661",
    className: "needle-cls-2",
    cx: 10,
    cy: 10,
    r: 10,
    transform: "translate(11.345 10.517)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeedle);
export default __webpack_public_path__ + "static/media/Needle.0b87f8a0c718ee2a8d8056666478d9e9.svg";
export { ForwardRef as ReactComponent };